<section>
  <div *ngIf="!submitted">
    <div class="page-header-container">
      <button
        mat-icon-button
        aria-label="Go back"
        (click)="onCancel()"
        class="back_icon"
      >
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h2 class="page-title" style="margin: 0">
        {{ assignment ? "Edit Assignment" : "Add Assignment" }}
      </h2>
    </div>
    <div class="bg-white">
      <form
        [formGroup]="form"
        (ngSubmit)="onSave()"
        class="assignment-form"
        style="padding: 1rem; border-radius: 8px"
      >
        <div
          *ngFor="let question of questions"
          class="mat-card"
          style="margin-bottom: 1rem; padding: 1rem; position: relative"
        >
          <app-question [question]="question" [form]="form"></app-question>
        </div>
        <div formArrayName="customQuestions">
          <div
            *ngFor="let q of customQuestions.controls; let i = index"
            [formGroupName]="i"
            class="mat-card"
            style="margin-bottom: 1rem; padding: 1rem; position: relative"
          >
            <mat-label style="font-weight: 600"><span translate>Question</span> {{ i + 1 }}</mat-label>
            <mat-form-field style="width: 100%; margin-top: 0.5rem">
              <mat-label translate>Enter your question</mat-label>
              <textarea matInput formControlName="text" rows="3"></textarea>
            </mat-form-field>
            <div
              style="
                display: flex;
                align-items: center;
                gap: 1rem;
                margin-top: 0.5rem;
              "
            >
              <mat-form-field style="width: 100px">
                <mat-label translate>Marks</mat-label>
                <input matInput type="number" formControlName="marks" />
              </mat-form-field>
              <input
                type="file"
                hidden
                #fileInput
                (change)="onFileSelected($event, i)"
              />

              <button
                mat-stroked-button
                color="primary"
                type="button"
                (click)="fileInput.click()"
              >
                <i class="fa-solid fa-paperclip"></i> <span translate>Add Attachments</span>
              </button>
              <span *ngIf="q.get('attachment')?.value">
                <i class="fa-solid fa-paperclip"></i>
                {{ q.get("attachment")?.value?.name }}
              </span>

              <button
                mat-icon-button
                color="warn"
                type="button"
                (click)="deleteQuestion(i)"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
          <button
            mat-stroked-button
            type="button"
            color="accent"
            (click)="addQuestion()"
            style="
              display: flex;
              align-items: center;
              gap: 0.5rem;
              margin-bottom: 1rem;
            "
          >
            <i class="fa-solid fa-plus"></i> <span translate>Add Question</span>
          </button>
        </div>

        <div
          class="deadline-row"
          style="
            display: flex;
            align-items: center;
            gap: 2rem;
            margin-bottom: 1rem;
            flex-wrap: wrap;
          "
        >
          <mat-form-field
            class="deadline-field"
            style="flex: 1; min-width: 250px"
          >
            <mat-label translate>Submission Deadline</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="deadline"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          <mat-slide-toggle
            formControlName="lateSubmission"
            style="white-space: nowrap"
            translate
          >
            Allow Late Submission
          </mat-slide-toggle>
        </div>

        <!-- ACTIONS -->
        <div
          class="actions-container"
          style="display: flex; justify-content: flex-end; gap: 1rem"
        >
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!form.valid"
          >
            {{ assignment ? "Update" : "Save" }}
          </button>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="submitted">
    <app-submitted-success-component
          [assignment]="assignment"
          [imageUrl]="imageUrl"
          [isSubmitted]="isSubmitted"
          [showDetails]="showDetails"
          [actiontaken] = "Created"
          [isDisabled]="isDisabled"
          (goBackEvent)="goBack()"
          (viewSubmissionDetailsEvent)="viewSubmissionDetails()"
        ></app-submitted-success-component>
  </div>
</section>
